import { EVENTS } from '../events';

/**
 * Delete plugin
 */
export class DeletePlugin {

	constructor(chat) {
		this.chat = chat;
	}

	init() {
		if (!this.chat.options.is_admin) {
			return true;
		}

		this.chat.on(EVENTS.WSCHAT_ON_RENDER_USER_META, info => this.add_delete_btn(info));

        this.chat.$el.on('click', '#wschat_delete_conversation', e => this.confirm_deletion(e))
	}

	add_delete_btn(meta_element) {
		const picker = jQuery(BTN_TEMPLATE);

		meta_element.append(picker);
	}

	confirm_deletion() {
		const confirmed = confirm('Are you sure? Want to delete the Conversation?');

		if (!confirmed) {
			return false;
		}

		this.chat.connector.delete_conversation(this.chat.conversation.id);
	}
}

export const BTN_TEMPLATE = `
	<div class="row mb-2">
		<div class="d-grid">
			<button id="wschat_delete_conversation" class="btn btn-block btn-sm btn-danger" title="Delete Conversation">
				<i class="material-icons align-bottom">delete</i> Delete Conversation
			</button>
		</div>
	</div>
`;
